import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e48bcf22"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"align-items":"start"},
  class: "lobby__wrapper f f-start-start f-wrap w-100"
}
const _hoisted_2 = { class: "left-container__content" }
const _hoisted_3 = {
  key: 0,
  class: "middle-container f"
}
const _hoisted_4 = { class: "f-grow f f-center-center" }
const _hoisted_5 = { class: "a-appear-zoom t-h1 mb-4" }
const _hoisted_6 = { class: "a-appear-bounce-up" }
const _hoisted_7 = {
  key: 1,
  style: {"flex-grow":"0"},
  class: "middle-container"
}
const _hoisted_8 = { class: "mb-2 f f-between-start" }
const _hoisted_9 = { class: "mb-2 w-100" }
const _hoisted_10 = { class: "w-100 f-row f-between-center" }
const _hoisted_11 = { class: "f f-center-center" }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "t-small" }
const _hoisted_14 = { class: "t-bold" }
const _hoisted_15 = { class: "f-row-1" }
const _hoisted_16 = { class: "mobile-buttons f-row-2 mb-2 mobile-buttons w-100" }
const _hoisted_17 = {
  key: 2,
  class: "middle-container"
}
const _hoisted_18 = { class: "h-100 w-100 f f-between-center" }
const _hoisted_19 = { class: "game-list mb-2 w-100 f-grow" }
const _hoisted_20 = { class: "f-start-start f-row-2" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "right-container__content f f-grow" }
const _hoisted_23 = { class: "chat__wrapper mb-2 f-grow" }
const _hoisted_24 = { class: "chat" }
const _hoisted_25 = { class: "chat__content" }
const _hoisted_26 = { class: "t-tiny chat__message__from" }
const _hoisted_27 = { class: "t-small chat__message__text" }

import PlayLobbyPlayers from "./PlayLobbyPlayers.vue";

import { computed, ref, Ref, nextTick } from "vue";
import { useStore } from "vuex";
import { ws } from "@/helpers/ws";
import { useRouter } from "vue-router";
import { v4 as uuidv4 } from "uuid";
import { GAMES } from "@/helpers/games";
import { playSound } from "@/helpers/sound";
interface ChatMessage {
    id: string;
    from: string;
    text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayLobby',
  setup(__props) {

const router = useRouter();
const store = useStore();

const room = computed(() => store.getters.room);
const isOwner = computed(() => room.value.owner === room.value.username);

const WILL_LAUNCH_TIMER_DURATION = 8;
const isWillLaunch = ref(false);
let willLaunchInterval: number;
let willLaunchTimerStart: number;
const willLaunchTimer = ref(0);
const willLaunchRerenderTrick = ref(true);

ws.handle("willLaunch", handleWillLaunch);
function handleWillLaunch() {
    store.commit("willLaunchGame");

    playSound("tick");
    isWillLaunch.value = true;
    willLaunchTimerStart = Date.now();
    willLaunchTimer.value = WILL_LAUNCH_TIMER_DURATION;

    willLaunchInterval = setInterval(async () => {
        const save = willLaunchTimer.value;

        willLaunchTimer.value =
            WILL_LAUNCH_TIMER_DURATION -
            Math.floor((Date.now() - willLaunchTimerStart) / 1000);
        willLaunchTimer.value = Math.max(0, willLaunchTimer.value);

        if (willLaunchTimer.value !== save) {
            playSound("tick");
            willLaunchRerenderTrick.value = false;
            await nextTick();
            willLaunchRerenderTrick.value = true;
        }
    }, 100);
}

function changeCurrentGame(id: number) {
    if (!isOwner.value) return;
    ws.changeCurrentGame(id);
    store.commit("setCurrentGame", id);
}

function play() {
    ws.play(room.value.currentGame);
}

function leave() {
    ws.leave();
}

function openAd() {
    window.open("https://lazone.io", "_blank").focus();
}

const isChatOpen = ref(false);
const toggleIsChatOpen = () => (isChatOpen.value = !isChatOpen.value);

const isPlayersOpen = ref(false);
const toggleIsPlayersOpen = () => (isPlayersOpen.value = !isPlayersOpen.value);

// Chat

ws.handle("chat", handleChatMessage);

const CHAT_HISTORY_LIMIT = 15;
const chatInput = ref("");
const chatHistory: Ref<[ChatMessage] | never[]> = ref([]);
function handleChatMessage(message: any) {
    chatHistory.value.unshift({
        ...message,
        id: uuidv4(),
    });

    if (chatHistory.value.length >= CHAT_HISTORY_LIMIT) chatHistory.value.pop();
}

function sendChat() {
    if (chatInput.value === "") return;
    chatHistory.value.unshift({
        id: uuidv4(),
        from: room.value.username,
        text: chatInput.value,
    });

    if (chatHistory.value.length >= CHAT_HISTORY_LIMIT) chatHistory.value.pop();
    ws.sendChat(chatInput.value);
    chatInput.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_SpinnerIcon = _resolveComponent("SpinnerIcon")!
  const _component_SimpleButton = _resolveComponent("SimpleButton")!
  const _component_SettingsIcons = _resolveComponent("SettingsIcons")!
  const _component_GameCard = _resolveComponent("GameCard")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({
                'left-container': true,
                'players--closed': !isPlayersOpen.value,
            })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PlayLobbyPlayers, { close: toggleIsPlayersOpen })
      ])
    ], 2),
    (isWillLaunch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SpinnerIcon)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t.play.lobby.willLaunch) + " ", 1),
              (_openBlock(), _createElementBlock("span", {
                key: willLaunchTimer.value,
                class: "d-ib a-appear-bounce-up"
              }, _toDisplayString(willLaunchTimer.value), 1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t.play.lobby.seconds), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isWillLaunch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SimpleButton, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (leave())),
                  style: {"--nth":"0s"},
                  icon: "chevron-left",
                  text: _ctx.$t.play.lobby.leave,
                  isSmall: ""
                }, null, 8, ["text"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(room).name), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.$t.play.lobby.roomId) + " : ", 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(room).id), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_SettingsIcons, { isBottom: "" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_SimpleButton, {
                class: "f-grow",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleIsPlayersOpen())),
                style: {"--nth":"0.1s"},
                icon: "users",
                text: `${_unref(room).playerCount} ${_ctx.$t.play.lobby.players}`,
                isSmall: ""
              }, null, 8, ["text"]),
              _createVNode(_component_SimpleButton, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleIsChatOpen())),
                style: {"--nth":"0.2s"},
                icon: "message",
                text: _ctx.$t.play.lobby.chat,
                isSmall: ""
              }, null, 8, ["text"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isWillLaunch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GAMES), (game, name, index) => {
                  return (_openBlock(), _createBlock(_component_GameCard, {
                    onClick: ($event: any) => (changeCurrentGame(index)),
                    isSelected: index === _unref(room).currentGame,
                    class: "col-6 col-sm-4",
                    game: game,
                    style: {"--nth":"0s"},
                    key: 
                                    Number(index === _unref(room).currentGame) * 10 +
                                    game.name
                                
                  }, null, 8, ["onClick", "isSelected", "game"]))
                }), 128))
              ])
            ]),
            (_unref(isOwner))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (Object.keys(_unref(room).players).length > 1)
                    ? (_openBlock(), _createBlock(_component_SimpleButton, {
                        key: 0,
                        text: _ctx.$t.play.lobby.start,
                        isFull: "",
                        icon: "gamepad",
                        style: {"--nth":"0s"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (play()))
                      }, null, 8, ["text"]))
                    : (_openBlock(), _createElementBlock("h3", _hoisted_21, _toDisplayString(_ctx.$t.play.lobby.notEnoughPlayers), 1))
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
                'f f-end-end right-container h-100': true,
                'chat--closed': !isChatOpen.value,
            })
    }, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "chat__close",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleIsChatOpen()))
          }, [
            _createVNode(_component_SimpleButton, { icon: "chevron-left" })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatHistory.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chat__message t-left",
                  key: message.id
                }, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(message.from), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(message.text), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_TextInput, {
          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (sendChat()), ["enter"])),
          modelValue: chatInput.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chatInput).value = $event)),
          icon: "chevron-right",
          placeholder: "Hey !"
        }, null, 8, ["modelValue"])
      ])
    ], 2)
  ]))
}
}

})